import { Box, Tabs, TabList, Tab, Select } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { hideIfNarrowerThan, hideIfWiderThan } from 'styles/style-utils';

const ResponsiveTabs = ({
  tabs,
  currentTab,
  getPath,
  mobileThreshold,
}: {
  tabs: { value: string; label: string }[];
  currentTab?: string;
  getPath: (string) => string;
  mobileThreshold: number;
}) => {
  const { push } = useRouter();
  const tabIndex = tabs.findIndex((c) => c.value === currentTab);

  return (
    <>
      {/* Mobile nav */}
      <Box sx={hideIfWiderThan(`${mobileThreshold + 1}px`)}>
        <Select
          value={currentTab}
          placeholder="Selectionner la catégorie"
          onChange={(e) => push(getPath(e.target.value))}
        >
          {tabs.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </Select>
      </Box>

      {/* desktop nav */}
      <Tabs
        sx={hideIfNarrowerThan(`${mobileThreshold}px`)}
        colorScheme="yellow"
        index={tabIndex !== -1 ? tabIndex : 0}
        onChange={(index) => push(getPath(tabs[index]?.value))}
        overflowX="auto"
      >
        <TabList>
          {tabs.map((c) => (
            <Tab key={c.value}>{c.label}</Tab>
          ))}
        </TabList>
      </Tabs>
    </>
  );
};

export default ResponsiveTabs;
